import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://www.arteeinfissi.com";

const TITLES = {
  "/": "Arte & Infissi — Infissi, Vetrate Panoramiche e Pergotende su misura | Cerveteri",
  "/prodotti": "Prodotti — Arte & Infissi",
  "/balaustre-in-vetro": "Balaustre in Vetro — Arte & Infissi",
  "/projects": "Realizzazioni — Arte & Infissi",
  "/about": "Azienda — Arte & Infissi",
  "/contact": "Contatti — Arte & Infissi",
};

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    selector.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/g)?.forEach((m) => {
      const [, k, v] = m.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/);
      el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.location.hostname === "arteeinfissi.com") {
      window.location.replace(`${SITE_URL}${window.location.pathname}${window.location.search}`);
      return;
    }
    const url = `${SITE_URL}${pathname === "/" ? "" : pathname.replace(/\/$/, "")}`;
    const title = TITLES[pathname] || (pathname.startsWith("/prodotti/") ? "Prodotti — Arte & Infissi" : pathname.startsWith("/projects/") ? "Realizzazioni — Arte & Infissi" : "Arte & Infissi");
    document.title = title;
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[name="twitter:title"]', "content", title);
  }, [pathname]);
  return null;
}
